export default {
    SELECTED_PARTICIPANT_CARD: 'selectedParticipantCard',
    HAVE_ARRIVED_CARD: 'haveArrivedCard'
};